import React from 'react';
import Navbar from './components/Navbar';
import Cover from './components/sections/Cover';
import Snapshot from './components/sections/Snapshot';
import Commitments from './components/sections/Commitments';
import Built from './components/sections/Built';
import Financials from './components/sections/Financials';
import Retention from './components/sections/Retention';
import Studio from './components/sections/Studio';
import Saudi from './components/sections/Saudi';
import Q1 from './components/sections/Q1';
import Plan from './components/sections/Plan';
import Help from './components/sections/Help';
import Closing from './components/sections/Closing';

export default function Report2025App() {
  return (
    <>
      <Navbar />
      <main>
        <Cover />
        <Snapshot />
        <Commitments />
        <Built />
        <Financials />
        <Retention />
        <Studio />
        <Saudi />
        <Q1 />
        <Plan />
        <Help />
        <Closing />
      </main>
    </>
  );
}
